<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
            font-weight-bold
            black--text
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
          "
          >{{ translations.label_delete_area }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        {{ translations.label_confirm_delete_area }}
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end" align="end">
            <v-btn
              color="primary"
              @click="close"
              text
              class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              {{ translations.cancel }}
            </v-btn>
            <v-btn
              color="primary"
              @click="deleteArea"
              text
              class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              {{ translations.accept }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
    name: String,
  },
  data: () => ({
    data: { error: false, message: "", name: "" },
  }),
  created() {
    this.data.name = this.name;
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    deleteArea() {
      this.$emit("deleteArea");
      this.show = false;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style scoped></style>
